import { combineReducers } from 'redux';
import { EventActionViewModel } from 'stageclip-common';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { ById } from '../store/normalizedState';

import * as ReducerHelper from './reducerHelper';

function allIdsReducer(state: string[] = [], action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.eventActions);
    case InternalActionTypes.EventArchivedActionsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.eventActions);
    default:
      return state;
  }
}

function byIdReducer(state: ById<EventActionViewModel> = {}, action: AllActions): ById<EventActionViewModel> {
  switch (action.type) {
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.eventActions);
    case InternalActionTypes.EventArchivedActionsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.eventActions);
    default:
      return state;
  }
}

export const eventActionsReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
